<!-- Password Reset 8 - Bootstrap Brain Component -->
<section class="bg-light p-3 p-md-4 p-xl-5">
    <div class="container-fluid">
      <div class="row justify-content-center">
        
        <div class="col-12 col-xxl-11">

          <div class="card border-light-subtle shadow-sm">
            <div class="row g-0">
              <div class="col-12 col-md-6">
                <img class="img-fluid rounded-start w-100 h-100 object-fit-cover"  src="assets/illustrators/forgot-password-illustrator/forgot-password.svg" alt="Welcome back you've been missed!">
              </div>
              <div class="col-12 col-md-6 d-flex align-items-center justify-content-center">
                <div class="col-12 col-lg-11 col-xl-10">
                  <div class="card-body p-3 p-md-4 p-xl-5">
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-5">
                          <!-- <div class="text-center mb-4">
                            <a href="#!">
                              <img src="./assets/img/bsb-logo.svg" alt="BootstrapBrain Logo" width="175" height="57">
                            </a>
                          </div> -->
                          <h2 class="h4 text-center">Password Reset</h2>
                          <h3 class="fs-6 fw-normal text-secondary text-center m-0">Provide the email address associated with your account to recover your password.</h3>
                        </div>
                      </div>
                    </div>
                    <form [formGroup]="ResetPasswordForm" (ngSubmit)="handleSubmit()">
                      <div class="row gy-3 overflow-hidden">

                        <div class="col-md-12 mt-1">
                          <div
                            class="input-field"
                            [ngClass]="{
                              'invalid-border':
                                ResetPasswordForm.controls.email.touched &&
                                ResetPasswordForm.controls.email.invalid
                            }"
                          >
                            <div
                              class="form-floating"
                              [ngClass]="{
                                'is-invalid':
                                  ResetPasswordForm.controls.email.touched &&
                                  ResetPasswordForm.controls.email.invalid
                              }"
                            >
                              <input
                                formControlName="email"
                                type="emailaddress"
                                class="form-control border-end-0"
                                id="emailaddress"
                                placeholder="Email"
                              />
                              <label for="email">Email address</label>
                            </div>
                            <div
                              class="invalid-feedback"
                              *ngIf="
                                ResetPasswordForm.controls.email.touched &&
                                ResetPasswordForm.controls.email.invalid
                              "
                            >
                              <span *ngIf="ResetPasswordForm.controls.email.errors.required"
                                >Email is mandatory.</span
                              >
                              <span *ngIf="ResetPasswordForm.controls.email.errors.pattern"
                                >Invalid Email</span
                              >
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12 mt-2">
                          <button
                            type="submit"
                            [ngClass]="{'button--loading': isLoading}"
                            [disabled]="isLoading"
                            class="btn btn-primary button--loading w-100"
                          >
                            <span class="button--text">Sign in</span>
                          </button>
                        </div>
            
                        
                      </div>
                    </form>
                    <div class="row">
                      <div class="col-12">
                        <div class="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center mt-5">
                          <a routerLink="/auth/login" class="link-secondary text-decoration-none">Login</a>
                          <a routerLink="/auth/signup" class="link-secondary text-decoration-none">Sign up</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
